import React, { useState } from 'react'
import { Link, Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import moment from 'moment'
import { Select as AntSelect, DatePicker, Menu, Dropdown, Popconfirm } from 'antd'

import { AiOutlineDown, AiOutlineReload, AiOutlineSetting } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'
import { BsBookshelf } from 'react-icons/bs'

import { normalize, stringifyDate, useListData, useToggle, usePet, server, useElevated } from '../modules'

import SelectStation from '../components/modals/selectstation'
import PayModal from '../components/modals/paymodal'
import OrderModal from '../components/modals/ordermodal'
import Receive from '../components/resusable/receive'
import ApplyDiscount from '../components/modals/applyDiscount'
import Confirm from '../components/resusable/confirm'
import Settings from '../components/modals/settings'
import OngoingShift from '../components/modals/ongoingshift'
import Complementary from '../components/modals/complementary'
import Shelf from '../components/modals/shelf'
import Elevated from '../components/modals/elevated'
import Void from '../components/modals/void'
import GuestBadge from '../components/resusable/guestBadge'
import PrintIFrame from '../components/modals/printIFrame'

import NewBill from '../components/drawers/newBill'
import AddToBill from '../components/drawers/addToBill'

const { RangePicker } = DatePicker

const Orders = () => {
    const [selected, setSelected] = useState()
    const [ranges, setRanges] = useState([])
    const [shifts, setShifts] = useState([])
    const [chosen, setChosen] = useState([])
    const [type, setType] = useState({ label: 'All', value: 'All' })
    const [shift, setShift] = useState()
    const [string, setString] = useState('')
    const [onSuccess, setOnSuccess] = useState(() => null)
    const [token, setToken] = useState()
    const [toPrint, setToPrint] = useState()

    const [payModal, togglePayModal] = useToggle()
    const [orderModal, toggleOrderModal] = useToggle()
    const [stationsModal, toggleStationsModal] = useToggle()
    const [discountModal, toggleDiscount] = useToggle()
    const [comp, toggleComplementary] = useToggle()
    const [select, toggleSelect] = useToggle()
    const [settings, toggleSettings] = useToggle()
    const [shelf, toggleShelf] = useToggle()
    const [shiftModal, toggleShift] = useToggle()
    const [voidB, toggleVoid] = useToggle()
    const [elevated, toggleElevated] = useToggle()
    const [iframeModal, toggleIFrameModal] = useToggle()

    const { user } = useSelector(state => state.application)

    const printerIsSet = !!localStorage.getItem('Bill');
    // const [launchElevated, Elevated] = useElevated()

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const [
        { loading, error, fetch },
        { list: orders },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('orders', ranges ? { string, type: type?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { type: type?.value, string }, { notify: true })

    const [, revoke] = usePet('revokeDiscount', {
        bill: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: 'Revoking discount...' }, token })

    const [, revokeComplementary] = usePet('revokeComplementary', {
        bill: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: 'Revoking complementary...' }, token })

    const [, toggleShelfBill] = usePet('toggleShelfBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: 'Removing bill from shelf...' } })

    const [, toggleWaiveBill] = usePet('toggleWaiveBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: selected?.waived ? 'Removing waiver...' : 'Waiving bill...' }, token })

    const [, toggleVoidBill] = usePet('toggleVoidBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: selected?.waived ? 'Undoing void...' : 'Voiding bill...' }, token })

    const [, openShifts] = usePet('openShift', null, {
        notify: true, callback: async ({ data }) => {
            setShifts(data ? [data] : [])

            if (data?.user?._id === user._id) {
                setShift(data)
            } else {
                toggleShift()
            }
        }
    })

    const [, startShift] = usePet('startShift', {}, {
        notify: true, callback: ({ data }, notif, ops) => {
            setShift(data)
            openShifts()
            notif('Shift has been started', ops('success'))
        }, manual: true, load: { msg: 'Starting new shift...' }
    })

    const [, endShift] = usePet('endShift', {
        id: shift?._id
    }, {
        notify: true, callback: ({ data }, notif, ops) => {
            setShift(null)
            openShifts()
            notif('Shift has been ended', ops('success'))
        }, manual: true, load: { msg: 'Ending shift...' }
    })

    const [{ loading: mLoading }, merge] = usePet('mergeBills', {
        ids: chosen
    }, {
        notify: true, callback: ({ }, notif, ops) => {
            notif('Bills have been merged', ops('success'))
            fetch()
            togSelect()
        }, manual: true, load: { msg: 'Merging bills...' }
    })

    const [{ loading: dLoading }, deleteBills] = usePet('deleteBills', {
        ids: chosen
    }, {
        notify: true, callback: ({ }, notif, ops) => {
            notif('Bills have been deleted', ops('success'))
            fetch()
            togSelect()
        }, manual: true, load: { msg: 'Deleting bills...' }
    })

    const [, printBill] = usePet('printBillByWaiter', { 
        bill: toPrint?._id,
        target: localStorage.getItem('Bill')
    }, { notify: true, callback: () => null, manual: true, load: { msg: 'Printing bill...' } })

    const print = order => {
        setToPrint(order)
        if (printerIsSet) {
            printBill()
        } else {
            toggleIFrameModal()
        }
    }

    const reload = () => {
        navigate(1)
        fetch()
    }

    const elevate = fn => {
        setOnSuccess({ fn, setToken })
        setTimeout(toggleElevated, 200)
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0) {
            fetch()
            navigate(1)
        }
    }

    const selectRange = range => {
        setRanges(range)
        navigate(1)
        fetch()
    }

    const viewOrder = ord => {
        setSelected(ord)
        toggleOrderModal()
    }

    const complementary = ord => {
        setSelected(ord)
        toggleComplementary()
    }

    const shelfBill = ord => {
        setSelected(ord)
        toggleShelf()
    }

    const discount = ord => {
        setSelected(ord)
        toggleDiscount()
    }

    const voidBill = ord => {
        setSelected(ord)
        toggleVoid()
    }

    const recordPayment = ord => {
        setSelected(ord)
        togglePayModal()
    }

    const changeType = val => {
        setType(val)
        navigate(1)
        fetch()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <PayModal
                onPerform={fetch}
                order={selected}
                toggle={togglePayModal}
                visible={payModal} />
            {
                orderModal &&
                <OrderModal
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleOrderModal}
                    visible={orderModal} />
            }
            {
                discountModal &&
                <ApplyDiscount
                    token={token}
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleDiscount}
                    visible={discountModal} />
            }
            {
                comp &&
                <Complementary
                    token={token}
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleComplementary}
                    visible={comp} />
            }
            {
                shelf &&
                <Shelf
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleShelf}
                    visible={shelf} />
            }
            {
                voidB &&
                <Void
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleVoid}
                    visible={voidB} />
            }
            {
                shiftModal &&
                <OngoingShift
                    setShift={setShift}
                    shifts={shifts}
                    toggle={toggleShift}
                    visible={shiftModal} />
            }
            {
                iframeModal &&
                <PrintIFrame
                    content="receipt"
                    visible={iframeModal} 
                    id={toPrint?._id}
                    toggle={toggleIFrameModal}
                    title={ `Bill #${ toPrint?.orderNo}` } />
            }
            <SelectStation
                toggle={toggleStationsModal}
                visible={stationsModal} />
            <Settings
                visible={settings}
                toggle={toggleSettings} />
            {
                elevated &&
                <Elevated
                    onSuccess={onSuccess}
                    toggle={toggleElevated}
                    visible={elevated} />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Waiter, Table or Receipt No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker
                        showTime
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }} />
                    <Dropdown
                        overlay={
                            <Menu>
                                {
                                    shifts?.length > 0 && !shift &&
                                    <Menu.Item onClick={toggleShift}>View Open Shifts</Menu.Item>
                                }
                                {
                                    shift ?
                                        <Popconfirm
                                            title="Please confirm that you would like to end this shift？"
                                            onConfirm={endShift}
                                            okText="Proceed">
                                            <Menu.Item>End Shift</Menu.Item>
                                        </Popconfirm>
                                        :
                                        <Popconfirm
                                            title={shifts.length > 0 ? "This will stop the current shift and start a new one" : "Are you sure you want start a new shift?"}
                                            onConfirm={startShift}
                                            okText="Proceed">
                                            <Menu.Item>Start New Shift</Menu.Item>
                                        </Popconfirm>
                                }
                            </Menu>
                        }>
                        <button className={`btn ${shift ? `hisani-btn-orange` : 'hisani-btn-green'} ml-2 text-white`}>
                            <span className="hidden xs:block">{shift ? `${shift.user.name}'s Shift Ongoing` : 'Select Shift'}</span>
                        </button>
                    </Dropdown>
                    {
                        user?.username === 'root' &&
                        <button onClick={toggleSettings} className="btn bg-indigo-500 ml-2 hover:bg-indigo-600 text-white">
                            <span className="hidden xs:block mr-2">Settings</span>
                            <AiOutlineSetting />
                        </button>
                    }
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Bills</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            value={type}
                            onChange={changeType}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={['All', 'Closed', 'Open', 'With Complementary', 'Voided', 'Shelved', 'Waived'].map(type => ({ label: type, value: type }))}
                            placeholder="Filter By Status" />
                        {
                            shift &&
                            <Link to="/app/bills/new">
                                <button className="btn ml-2 hisani-btn-green text-white">
                                    <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                    <span className="hidden xs:block ml-2">New Sale</span>
                                </button>
                            </Link>
                        }
                        <button onClick={reload} className="btn ml-2 py-3 hisani-btn-green text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        {
                            chosen.length > 0 ?
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                            {
                                                chosen.length > 1 ?
                                                    <Menu.Item onClick={() => elevate(() => {
                                                        Confirm({
                                                            title: 'Merge Selected Bills?',
                                                            message: 'Please confirm before taking this action',
                                                            okText: 'Merge Bills',
                                                            onOk: merge
                                                        })
                                                    })}>Merge {chosen.length} Bills</Menu.Item>
                                                    : null
                                            }
                                            {
                                                user?.username == 'root' ?
                                                    <Menu.Item onClick={() => elevate(() => {
                                                        Confirm({
                                                            title: 'Delete Bills?',
                                                            message: 'Please note that this action is not reversable',
                                                            okText: 'Delete Bills',
                                                            onOk: deleteBills
                                                        })
                                                    })}>Delete</Menu.Item>
                                                    : null
                                            }
                                        </Menu>
                                    }>
                                    <button className="btn bg-indigo-500 ml-2 hover:bg-indigo-600 text-white">
                                        <span className="hidden xs:block mr-2">Bulk Actions ({chosen.length})</span>
                                        <AiOutlineDown />
                                    </button>
                                </Dropdown>
                                :
                                <button onClick={togSelect} className="btn ml-2 hisani-btn-green text-white">
                                    <BiSelectMultiple style={{ color: "white" }} />
                                    <span className="hidden xs:block ml-2">{!select ? "Select" : "Deselect All"}</span>
                                </button>
                        }
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            orders.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Receipt No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Amount</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Table / Room</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Served By</div>
                                                </th>
                                                {
                                                    type?.value !== 'All' && type?.value !== 'Open' && type?.value !== 'Closed' ?
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">
                                                                {
                                                                    type?.value === 'Shelved' ? 'Shelved By'
                                                                        : 'Authorized By'
                                                                }
                                                            </div>
                                                        </th>
                                                        : null
                                                }
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                orders.map((order, key) => {
                                                    let checkedIn = order.items.some(itm => itm.recurring)

                                                    return (
                                                        <tr>
                                                            <td className="p-2">
                                                                <div className="text-center">
                                                                    {
                                                                        select && !order.closed ?
                                                                            <input
                                                                                onChange={() => choose(order._id)}
                                                                                checked={chosen.includes(order._id)}
                                                                                type="checkbox"
                                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                                            :
                                                                            `${((page - 1) * limit) + (key + 1)}.`
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="">#{order.orderNo}</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-center">Ksh. {normalize(order.items.reduce((total, item) => total + (item.quantity * item.unitPrice), 0) - (order.discount ?? 0))}</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className={`text-center ${(order.waived || order.voided) ? 'text-red-400' : order.closed ? 'text-green-500' : order.shelved ? 'text-blue-500' : 'text-yellow-500'}`}>{order.waived ? 'Waived' : order.voided ? 'Voided' : order.closed ? checkedIn ? 'Vacated' : 'Closed' : checkedIn ? 'Checked In' : order.shelved ? 'Shelved' : 'Open'}{order.discount ? ' (Disc)' : ''}{order.complementary ? ' (Comp)' : ''}</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-center">{checkedIn ? order.items.find(itm => itm.recurring).name : order.table}</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-center">{order.servedBy.name}</div>
                                                            </td>
                                                            {
                                                                type?.value !== 'All' && type?.value !== 'Open' && type?.value !== 'Closed' ?
                                                                    <td className="p-2">
                                                                        <div className="text-center">
                                                                            {
                                                                                type?.value === 'Shelved' ? order.shelvedBy?.name
                                                                                    : type?.value === 'With Complementary' ? order.complementaryAuthBy?.name
                                                                                        : type?.value === 'Voided' ? order?.voidedBy?.name
                                                                                            : order.waivedBy?.name
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    : null
                                                            }
                                                            <td className="p-2">
                                                                <div className="text-center">{stringifyDate(order.date)}</div>
                                                            </td>
                                                            <td className="p-2 text-center">
                                                                <GuestBadge show={checkedIn}>
                                                                    <Dropdown
                                                                        overlay={
                                                                            <Menu>
                                                                                <Menu.Item onClick={() => viewOrder(order)}>View</Menu.Item>
                                                                                {
                                                                                    !order.closed && !order.waived && !order.voided && shift &&
                                                                                    <>
                                                                                        <Menu.Item onClick={() => {
                                                                                            if (!order.shelved) {
                                                                                                shelfBill(order)
                                                                                                return
                                                                                            }
                                                                                            setSelected(order)

                                                                                            Confirm({
                                                                                                title: 'Remove from Shelf',
                                                                                                message: 'Please note that you won\'t be able to end your shift until this bill is settled',
                                                                                                okText: 'Remove from Shelf',
                                                                                                onOk: toggleShelfBill
                                                                                            })
                                                                                        }}>{order.shelved ? 'Remove from Shelf' : 'Shelf Bill'}</Menu.Item>
                                                                                        <Menu.Item onClick={() => recordPayment(order)}>Record Payments</Menu.Item>
                                                                                        <Menu.Item onClick={() => elevate(() => {
                                                                                            setSelected(order)
                                                                                            if (!order.voided) {
                                                                                                voidBill(order)
                                                                                                return
                                                                                            }
                                                                                        })}>{order.voided ? 'Undo Void Bill' : 'Void Bill'}</Menu.Item>
                                                                                        <Menu.Item><Link to={`/app/bills/add/${order._id}`}>Add Items</Link></Menu.Item>
                                                                                        <Menu.Item onClick={() => elevate(() => {
                                                                                            setSelected(order)

                                                                                            Confirm({
                                                                                                title: order.waived ? 'Remove Waiver' : 'Waive Bill',
                                                                                                message: order.waived ? 'This will remove the waiver on this bill' : 'This will place a waiver on this bill',
                                                                                                okText: order.waived ? 'Remove Waiver' : 'Waive Bill',
                                                                                                onOk: toggleWaiveBill
                                                                                            })
                                                                                        })}>{order.waived ? 'Remove Waiver' : 'Waive Bill'}</Menu.Item>
                                                                                        {
                                                                                            !order.waived ?
                                                                                                <>
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        if (!order.discount) {
                                                                                                            discount(order)
                                                                                                            return
                                                                                                        }
                                                                                                        setSelected(order)

                                                                                                        Confirm({
                                                                                                            title: 'Revoke discount',
                                                                                                            message: `This will remove the applied discount of Ksh. ${order.discount}`,
                                                                                                            okText: 'Revoke Discount',
                                                                                                            onOk: revoke
                                                                                                        })
                                                                                                    })}>{order.discount ? `Revoke Discount (Ksh. ${order.discount})` : 'Apply Discount'}</Menu.Item>
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        if (!order.complementary) {
                                                                                                            complementary(order)
                                                                                                            return
                                                                                                        }
                                                                                                        setSelected(order)

                                                                                                        Confirm({
                                                                                                            title: 'Revoke Complementary',
                                                                                                            message: `This will remove the given complmentary of Ksh. ${order.complementary}`,
                                                                                                            okText: 'Revoke Complementary',
                                                                                                            onOk: revokeComplementary
                                                                                                        })
                                                                                                    })}>{order.complementary ? `Revoke Complementary (Ksh. ${order.complementary})` : 'Give Complementary'}</Menu.Item>
                                                                                                </> : null
                                                                                        }
                                                                                        <Menu.Item onClick={() => recordPayment(order)}>Record Payments</Menu.Item>
                                                                                    </>
                                                                                }
                                                                                {
                                                                                    ((order.closed || order.waived) && shift && (order.complementary || order.discount || order.waived)) || order.voided ?
                                                                                        <>
                                                                                            {
                                                                                                order.waived ?
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        setSelected(order)

                                                                                                        Confirm({
                                                                                                            title: "Remove Waiver",
                                                                                                            message: "This will remove the waiver on this bill",
                                                                                                            okText: "Remove Waiver",
                                                                                                            onOk: toggleWaiveBill
                                                                                                        })
                                                                                                    })}>Remove Waiver</Menu.Item>
                                                                                                    : null
                                                                                            }
                                                                                            {
                                                                                                order.voided ?
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        setSelected(order)

                                                                                                        Confirm({
                                                                                                            title: 'Undo Void',
                                                                                                            message: 'Please confirm before undoing void action',
                                                                                                            okText: 'Undo Void',
                                                                                                            onOk: toggleVoidBill
                                                                                                        })
                                                                                                    })}>Undo Void</Menu.Item>
                                                                                                    : null
                                                                                            }
                                                                                            {
                                                                                                order.discount ?
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        setSelected(order)
                                                                                                        Confirm({
                                                                                                            title: 'Revoke discount',
                                                                                                            message: `This will remove the applied discount of Ksh. ${order.discount}`,
                                                                                                            okText: 'Revoke Discount',
                                                                                                            onOk: revoke
                                                                                                        })
                                                                                                    })}>Revoke Discount (Ksh. {order.discount})</Menu.Item>
                                                                                                    : null
                                                                                            }
                                                                                            {
                                                                                                order.complementary ?
                                                                                                    <Menu.Item onClick={() => elevate(() => {
                                                                                                        setSelected(order)
                                                                                                        Confirm({
                                                                                                            title: 'Revoke Complementary',
                                                                                                            message: `This will remove the given complmentary of Ksh. ${order.complementary}`,
                                                                                                            okText: 'Revoke Complementary',
                                                                                                            onOk: revokeComplementary
                                                                                                        })
                                                                                                    })}>Revoke Complementary (Ksh. {order.complementary})</Menu.Item>
                                                                                                    : null
                                                                                            }
                                                                                        </>
                                                                                        : null
                                                                                }
                                                                                <Menu.Item onClick={ () => print(order) }>Print Bill</Menu.Item>
                                                                            </Menu>
                                                                        }>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </GuestBadge>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">{string.trim().length > 2 ? `No bills matching "${string}" found` : type?.value === 'All' ? "Please click above to add a new order" : type?.value === 'Open' ? 'No open bills found' : type?.value === 'Shelved' ? 'No shelved bills found' : type?.value === 'Cancelled' ? 'No cancelled bills found' : 'No waived bills found'}</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route exact path="/app/bills/new">
                    <NewBill onComplete={reload} />
                </Route>
                <Route exact path="/app/bills/add/:id">
                    <AddToBill onComplete={reload} />
                </Route>
            </Switch>
        </div>
    )
}

export default Orders